<template>
    <div>
        <div class="proofs-container">
            <div class="proofs-grid">
                <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                <div v-if="(!errors && !loading && (items.length == 0))" class="alert alert-warning" role="alert">
                    {{ $root.text('There are no scenes that match your selection', null, true) }}
                </div>

                <div v-if="(items.length > 0)" class="row">
                    <div
                        v-for="item in items"
                        :key="item.id"
                        :class="($root.is_3xl_screen ? 'col-xl-3 ' : '') + ($root.is_xl_screen ? 'col-lg-4 ' : '')
                            +'col-md-6'"
                    >
                        <img-ly-scene-preview :data="item"></img-ly-scene-preview>
                    </div>
                </div>
            </div>
        </div>

        <div style="position: relative; top: -20px; height: 40px; overflow: visible">
            <loading v-if="loading"></loading>
        </div>

        <!--<proof-filters :proof_filters="$root.proof_filters" :proof_users="result_proof_users"></proof-filters>-->

        <div
            v-if="$root.hasPermission('templates_import_img_ly_scenes')"
            class="modal fade"
            id="img-ly-scene-import-modal"
            data-backdrop="static"
            data-keyboard="false"
            tabindex="-1"
            aria-labelledby="img-ly-scene-import-modal-label"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-scrollable" style="transition: max-width .35s ease">
                <img-ly-scene-import></img-ly-scene-import>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce';
    export default {
        data () {
            return {
                component_name: 'img-ly-scenes',
                loading: false,
                errors: false,
                items: [],
                total_items: 0,
                current_page: 1,
                last_page: 1
            }
        },
        created () {
            this.handleDebouncedScroll = debounce(this.handleScroll, 100);
            window.addEventListener('scroll', this.handleDebouncedScroll);
        },
        mounted () {
            $('body').removeClass('login-body');
            
            if (!this.$root.hasPermission('templates_manage_img_ly_scenes')) {
                this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                return false;
            }
            this.getScenes();
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleDebouncedScroll);
        },
        watch: {
            total_items: function (val) {
                this.$root.status_info.right = (val == 1)
                    ? this.$root.text('1 scene')
                    : this.$root.text('{x} scenes', {x: val });
            }
        },
        methods: {
            getScenes: function (page = 1) {
                if (this.loading || (page < 1) || ((page > 1) && (page <= this.current_page))) {
                    return false;
                }
                var vm = this;
                this.current_page = page;
                this.loading = true;
                this.errors = false;
                if (page == 1) {
                    this.items = [];
                    this.total_items = 0;
                    this.current_page = 1;
                    this.last_page = 1;
                }

                /*let filters = [this.isArchive() ? 'archived' : '!archived'];
                if (this.isFoldersView()) {
                    filters.push('folders');
                }
                let filteredByUser = false;
                let filteredByCanReview = false;
                let sorted = false;
                this.$root.proof_filters.forEach((item) => {
                    if (item.key == 'keyword') {
                        filters.push('kw::' + this.$root.base64Encode(item.value));
                    }
                    if (item.key == 'folder') {
                        filters.push('fr::' + item.value);
                    }
                    if (item.key == 'user') {
                        if (item.value > 0) {
                            filters.push('pu::' + item.value);
                        }
                        filteredByUser = true;
                    }
                    if (item.key == 'can_review') {
                        filteredByCanReview = item.value;
                        if (item.value == 1) {
                            filters.push('can-review');
                        }
                    }
                    if (item.key == 'date_range') {
                        filters.push('dr::' + item.value);
                    }
                    if (item.key == 'sort_by') {
                        filters.push('sb::' + item.value);
                        sorted = true;
                    }
                });
                const filtersString = (filters.length > 0) ? '/' + filters.join('|') : '';*/

                /**
                 * Send get IMG.LY scenes request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/img-ly-scenes' + '?page=' + page;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.total_items = response.data.scenes.total;
                    vm.current_page = response.data.scenes.current_page;
                    vm.last_page = response.data.scenes.last_page;
                    response.data.scenes.data.forEach((item) => {
                        // Duplicate display protection - check if already added.
                        let itemIndex = -1;
                        vm.items.forEach((existingItem, existingItemIndex) => {
                            if (item.id == existingItem.id) {
                                itemIndex = existingItemIndex;
                            }
                        });
                        if (itemIndex < 0) {
                            vm.items.push(item);
                        }
                    });
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response.status == 401) {
                        // Missing/lost API token - logout user.
                        vm.$root.doLogout();
                    }
                    if (error.response.data.error) {
                        vm.errors = error.response.data.error;
                    }
                })
                .finally(() => {
                    vm.loading = false;
                });
            },
            handleScroll(event) {
                if ((this.current_page < this.last_page) && !this.loading) {
                    const pageScrollTop = $('html, body').scrollTop();
                    const appHeight = $('#app').outerHeight();
                    const windowHeight = $(window).height();
                    const scrollPosition = appHeight - (pageScrollTop + windowHeight);
                    if (scrollPosition < 200) {
                        this.getScenes(this.current_page + 1);
                    }
                }
            }
        }
    }
</script>
